import Vue from "vue";

import { EXERCISE_TYPE } from "@tt-app/constants";
import { DrillAllObjects, DrillAllQuestions, ExerciseType } from "@tt-app/models/exercise";

import IconDrillListening from "@joyz/app-core/assets/icons/black/DrillListening.svg";
import IconDrillPronunciation from "@joyz/app-core/assets/icons/black/DrillPronunciation.svg";
import IconDrillVocabulary from "@joyz/app-core/assets/icons/black/DrillVocabulary.svg";

/**
 *
 * @param page
 * @returns the first drill question in a page, if it exists
 */
export const findDrillQuestion = (page: DrillAllObjects[]): DrillAllQuestions | undefined => {
  const question = page.find(
    (comp): comp is DrillAllQuestions =>
      comp?.type === "DRILL_LISTENING" ||
      comp?.type === "DRILL_PRONUNCIATION" ||
      comp?.type === "DRILL_VOCABULARY"
  );

  return question;
};

/**
 * Get the exercise type depending on the currently active route. Error is thrown
 * if route is invalid
 *
 * @param component view component
 * @returns the exercise type associated to the current route
 */
export const getExerciseTypeFromRoute = <V extends Vue>(component: V): ExerciseType => {
  const routePath = component.$route.fullPath;

  if (routePath.includes("drill-listening")) {
    return EXERCISE_TYPE.DRILL_LISTENING;
  } else if (routePath.includes("drill-pronunciation")) {
    return EXERCISE_TYPE.DRILL_PRONUNCIATION;
  } else if (routePath.includes("drill-vocabulary")) {
    return EXERCISE_TYPE.DRILL_VOCABULARY;
  }

  // TODO: how such error has to be handled?
  throw new Error(`Invalid drill path`);
};

/**
 *
 * @param exerciseType
 * @returns the active drill icon depending on the exercise type
 */
export const getDrillTypeIcon = (exerciseType: ExerciseType): string => {
  switch (exerciseType) {
    case EXERCISE_TYPE.DRILL_LISTENING:
      return IconDrillListening;
    case EXERCISE_TYPE.DRILL_PRONUNCIATION:
      return IconDrillPronunciation;
    case EXERCISE_TYPE.DRILL_VOCABULARY:
      return IconDrillVocabulary;
    default:
      throw new Error(`Unsupported drill exercise type: ${exerciseType}`);
  }
};
